import {
    ActionTypes,
    doesWorkflowRejectCodeExist,
    getWorkflowRejectCodeMessage
} from '@tassat/common-definitions';
import { IFormValues } from '@tassat/forms/src/ApiConnectionForm/types';
import { APIAddConnectionReq, APIModifyConnectionReq } from '@tassat/fred-definitions';
import moment from 'moment';

import Worker from 'Lib/worker/PrimusWorker';

export const submitApiConnection = async (values: IFormValues, opts: {
    actionType: ActionTypes;
    audiencePrefix: string;
    onClose: () => void;
    setSubmitError: React.Dispatch<React.SetStateAction<string>>;
}) => {
    const {
        actionType,
        audiencePrefix,
        onClose,
        setSubmitError
    } = opts;

    try {
        let response = { data: undefined };

        if (actionType === ActionTypes.add) {
            const submitDate = moment(values.EffectiveDate)
                .format('x');
            for (const key in values) {
                if (typeof values[key] === 'string') {
                    values[key] = values[key].trim();
                }
            }

            const audience = audiencePrefix + values.Audience.trim();

            const createRequest: Omit<
                APIAddConnectionReq,
                'UUID' |
                'RequestId' |
                'RequesterId' |
                'RequestType' |
                'RequestPattern' |
                'IpAddress1' |
                'IpAddress2' |
                'IsAdminAPI'
            > = {
                APIConnectionName: values.APIConnectionName.trim(),
                APIFirmContactName: values.APIFirmContactName.trim(),
                APIFirmEmail: values.APIFirmEmail,
                APIFirmPhone: values.APIFirmPhone.trim(),
                Audience: audience,
                SourceId: values.SourceId.trim(),
                EffectiveDate: submitDate
            };

            response = await Worker.getInstance()
                .createAPIConnection(createRequest);
        } else if (actionType === ActionTypes.edit) {
            const submitDate = moment(values.EffectiveDate)
                .format('x');
            const id = values.APIConnectionId;

            const editRequest: Omit<
                APIModifyConnectionReq,
                'UUID' |
                'RequestId' |
                'RequesterId' |
                'RequestType' |
                'RequestPattern' |
                'IpAddress1' |
                'IpAddress2' |
                'IsAdminAPI' |
                'Audience' |
                'SourceId' |
                'APIId' |
                'ClientId' |
                'IsLocked' |
                'IsDeleted' |
                'IsLockout' |
                'IsLockoutTriggered'
            > = {
                APIConnectionId: id,
                APIConnectionName: values.APIConnectionName.trim(),
                APIFirmContactName: values.APIFirmContactName.trim(),
                APIFirmEmail: values.APIFirmEmail,
                APIFirmPhone: values.APIFirmPhone.trim(),
                EffectiveDate: submitDate
            };

            response = await Worker.getInstance()
                .updateAPIConnection(editRequest);
        }

        if (response.data && response.data.Status === 48) {
            onClose();
        } else if (response.data && response.data.Status === 49) {
            setSubmitError(`Could not add API connection: ${response.data.Reason || 'Something went wrong'}`);
        } else if (response.data && doesWorkflowRejectCodeExist(response.data.Status)) {
            setSubmitError(`Could not add API connection: ${getWorkflowRejectCodeMessage(response.data.Status)}`);
        }
    } catch (error) {
        setSubmitError('Something went wrong');
    }
};